module.exports = __webpack_public_path__ + "static/img/5.6a312cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/5.png
// module id = G9hI
// module chunks = 0